import React from 'react';

import { Snackbar, Typography } from 'wtb-components';
import { useAppContext, useBillingContext, useLocaleContext } from 'context';
import styles from './EmailValidationSnackbar.module.css';

const EmailValidationSnackbar = () => {
  const { translate } = useLocaleContext();
  const { billing } = useBillingContext();
  const {
    setIsEmailValidationSnackbarOpen,
    isEmailValidationSnackbarOpen
  } = useAppContext();

  const closeSnackBar = () => {
    setIsEmailValidationSnackbarOpen(false);
  };

  const message = (
    <div className={styles.message}>
      <Typography variant="body2">
        {translate('emailValidation.snackbarTitle')}
      </Typography>
      <Typography variant="body2">
        {billing?.email}
      </Typography>
    </div>
  );

  return (
    <Snackbar
      id="email-checked-popup"
      open={isEmailValidationSnackbarOpen}
      className={styles.snackbar}
      ContentProps={{ className: styles.content }}
      message={message}
      handleClose={closeSnackBar}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    />
  );
};

export default EmailValidationSnackbar;
